import { Box, Typography, Paper } from '@mui/material';
import { FaUserCircle } from 'react-icons/fa';
import { avatarList } from '../../../../reusable-component/LoginForm';
import { ETL_COPILOT } from '../copilot-constant/Images';

const ChatBubble = ({ sender, message, showAvatar = false, withAvatar = false }) => {
  const isUser = sender === 'user';

  const storedId = typeof window !== 'undefined' ? JSON.parse(sessionStorage.getItem('avatar_id')) : null;
  const selectedAvatar = avatarList.find((avatar) => avatar.id === storedId);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: withAvatar && isUser ? 'row-reverse' : 'row',
        alignItems: 'flex-start',
        justifyContent: !withAvatar ? (isUser ? 'flex-end' : 'flex-start') : undefined,
        my: withAvatar ? 1.5 : 1,
        pl: withAvatar && !isUser && !showAvatar ? '65px' : 0,
        pr: withAvatar && isUser && !showAvatar ? '65px' : 0,
      }}
    >
      {withAvatar && showAvatar && (
        <Box sx={{ width: 40, height: 40, mx: 1.5 }}>
          {isUser ? (
            selectedAvatar ? (
              <img
                src={selectedAvatar.src}
                alt="User Avatar"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
              />
            ) : (
              <FaUserCircle size={40} />
            )
          ) : (
            <img
              src={ETL_COPILOT.LOGO}
              alt="Copilot"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
            />
          )}
        </Box>
      )}

      <Paper
        elevation={2}
        sx={{
          padding: withAvatar ? '8px 14px' : '8px 12px',
          maxWidth: withAvatar ? '75%' : '85%',
          bgcolor: isUser ? '#e0f7fa' : '#f1f1f1',
          borderRadius: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            fontSize: withAvatar ? '1rem' : '0.9rem',
          }}
        >
          {message}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ChatBubble;
